// eslint-disable-next-line import/prefer-default-export
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILED = 'GET_USER_PROFILE_FAILED';

export const SET_TWO_FACTOR_STATUS = 'SET_TWO_FACTOR_STATUS';

export const SET_NEED_TO_LINK_INITIATIVE = 'SET_NEED_TO_LINK_INITIATIVE';

export const CONNECT_INNITITATIVE_REQUEST = 'CONNECT_INNITITATIVE_REQUEST';
export const CONNECT_INNITITATIVE_SUCCESS = 'CONNECT_INNITITATIVE_SUCCESS';
export const CONNECT_INNITITATIVE_FAILED = 'CONNECT_INNITITATIVE_FAILED';

export const SET_POST_AUTH_REDIRECT_URL = 'SET_POST_AUTH_REDIRECT_URL';
export const CLEAR_POST_AUTH_REDIRECT_URL = 'CLEAR_POST_AUTH_REDIRECT_URL';
